const namespace = 'Login';

export const SET_FORGOTTEN_PASSWORD_TEXT = `${namespace}/SET_FORGOTTEN_PASSWORD_TEXT`;
